/**
 * Push messaging port — web implementation.
 *
 * Browser push is not part of the web release scope, so device registration
 * simply reports "no token" and the backend skips push targeting for this session.
 */
export interface GetFCMTokenOptions {
  forceRefresh?: boolean;
}

export const getFCMToken = async (
  _options: GetFCMTokenOptions = {},
): Promise<string | null> => null;
